import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import { useAuth } from '../context/AuthContext';
import flexbeeLogo from '../assets/media/flexbee-no-bg.webp';

// Korumalı alanın kapısı.
//
// SORUN: `Layout` (kenar çubuğu + üst şerit) korumanın DIŞINDA mount ediliyordu.
// `ProtectedRoute` oturum kontrolü sürerken yalnız `null` döndürdüğü için kullanıcı
// önce boş uygulama kabuğunu görüyor, `getMe()` sonuçlanınca login'e atılıyordu —
// "önce içeri girip sonra dışarı atılma" görüntüsü (müşteri geri bildirimi 2026-08-12).
//
// Artık kabuk, oturumun geçerli olduğu bilinmeden HİÇ mount edilmiyor:
//   - kontrol sürerken  → marka açılış ekranı
//   - oturum yok        → doğrudan /login (gidilmek istenen adres korunarak)
//   - oturum var        → uygulama
export default function AuthGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Splash />;

  if (!user) {
    const redirectPath = location.pathname + location.search;
    return <Redirect to={`/login?redirect=${encodeURIComponent(redirectPath)}`} />;
  }

  return children;
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1;   transform: scale(1); }
  50%      { opacity: 0.6; transform: scale(0.96); }
`;

const Screen = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.bgColor};
  /* Anlık çözülen oturumlarda ekranın "parlayıp geçmesini" önler: açılış ekranı
     yalnız kontrol gerçekten sürerse görünür hâle gelir. */
  animation: ${fadeIn} 0.25s ease-in 0.15s both;
  z-index: 9999;
`;

const Mark = styled.img`
  width: 132px;
  max-width: 40vw;
  animation: ${pulse} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

function Splash() {
  return (
    <Screen role="status" aria-live="polite">
      <Mark src={flexbeeLogo} alt="Flexbee" />
    </Screen>
  );
}
